import { createUseApiRequest } from 'swagger-client';
import { watch } from 'vue';

import type { MulticlusterRequestParams } from '@/api-client';
import { getProxyClusterId } from '@/api-client';
import { useUserStore } from '@/stores/user';

type CustomUseApiRequestConfigOptions = {
  resetCacheWhenLogout?: boolean;
};

export const useApiRequest = createUseApiRequest<
  MulticlusterRequestParams,
  CustomUseApiRequestConfigOptions
>({
  decorateCacheKey: (key, requestParams) => {
    const { shouldNotBeProxied, clusterId } = requestParams ?? {};

    const clusterIdToProxyTo = getProxyClusterId(clusterId, shouldNotBeProxied);

    if (clusterIdToProxyTo !== undefined) {
      return key + ';' + clusterIdToProxyTo;
    }

    return key;
  },
  setupResetCacheWatcher: (onResetCache, { resetCacheWhenLogout = false }) => {
    if (resetCacheWhenLogout) {
      const userStore = useUserStore();
      watch(
        () => userStore.authUser,
        (newUser) => {
          if (newUser === undefined) onResetCache();
        },
      );
    }
  },
});
